import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import DeviceGuard from './components/DeviceGuard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <DeviceGuard>
      <App />
    </DeviceGuard>
  </React.StrictMode>
);

reportWebVitals();
